import { Check, Sparkles } from "lucide-react";
import { IMAGES, PARTNERSHIP_WAYS, PARTNER_CATEGORIES, MEDIA_KIT_URL } from "@/lib/content";
import { Reveal, Eyebrow, PrimaryButton, GhostButton } from "@/components/site/ui";
import { scrollToId } from "@/components/sections/utils";

const WHY = ["Sport", "Wellness", "Lifestyle", "Beauty", "Food", "Women's Empowerment"];

export function Partnerships() {
  return (
    <section id="partnerships" className="relative isolate py-20 md:py-32 overflow-hidden">
      <div className="absolute inset-0 -z-10">
        <img src={IMAGES.sunsetSky} alt="" className="h-full w-full object-cover" />
        <div className="absolute inset-0 bg-ivory/88" />
      </div>
      <div className="max-w-7xl mx-auto px-5 sm:px-6 md:px-12">
        <div className="text-center max-w-3xl mx-auto">
          <Reveal><Eyebrow>Partnerships</Eyebrow></Reveal>
          <Reveal delay={0.05}><h2 className="mt-4 font-heading text-4xl md:text-6xl text-ink">Partner With Leah</h2></Reveal>
          <Reveal delay={0.1}><p className="mt-5 font-accent text-xl md:text-3xl italic text-bronze">Authentic storytelling. Meaningful partnerships. Shared values.</p></Reveal>
        </div>

        <div className="mt-10 md:mt-12 grid lg:grid-cols-2 gap-8 md:gap-10 items-center">
          <Reveal><div className="overflow-hidden rounded-[1.5rem] md:rounded-[2rem] border border-champagne/30"><img src={IMAGES.blockStart} alt="Leah Thames exploding out of the blocks" className="w-full object-cover object-top aspect-[4/3]" /></div></Reveal>
          <div>
            <Reveal><p className="label-eyebrow">Why Leah</p><h3 className="mt-3 font-heading text-2xl md:text-4xl text-ink leading-tight">The modern female athlete.</h3></Reveal>
            <Reveal delay={0.08}>
              <div className="mt-6 flex flex-wrap gap-2 md:gap-3">
                {WHY.map((w) => (<span key={w} className="rounded-full bg-blush/20 border border-blush/40 px-4 py-2 md:px-5 md:py-2.5 font-heading text-base md:text-lg text-ink">{w}</span>))}
              </div>
            </Reveal>
          </div>
        </div>

        <div className="mt-12 md:mt-16 grid lg:grid-cols-2 gap-8 md:gap-10">
          <Reveal>
            <div>
              <Eyebrow>Ways To Work Together</Eyebrow>
              <div className="mt-5 grid grid-cols-1 sm:grid-cols-2 gap-3">
                {PARTNERSHIP_WAYS.map((w) => (
                  <div key={w} className="rounded-2xl bg-ivory border border-champagne/30 p-4 flex items-center gap-3"><span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-blush/30 text-bronze"><Check size={15} /></span><p className="font-body text-sm text-ink/80">{w}</p></div>
                ))}
              </div>
            </div>
          </Reveal>
          <Reveal delay={0.1}>
            <div>
              <Eyebrow>Ideal Partner Categories</Eyebrow>
              <div className="mt-5 grid grid-cols-1 sm:grid-cols-2 gap-3">
                {PARTNER_CATEGORIES.map((c) => (
                  <div key={c} className="rounded-2xl bg-gradient-to-br from-blush/20 to-champagne/10 border border-champagne/30 p-4 flex items-center gap-3"><Sparkles size={16} className="text-bronze shrink-0" /><p className="font-heading text-base md:text-lg text-ink">{c}</p></div>
                ))}
              </div>
            </div>
          </Reveal>
        </div>

        <Reveal delay={0.1}>
          <div className="mt-12 md:mt-14 rounded-[1.75rem] md:rounded-[2.5rem] bg-ink text-ivory p-7 sm:p-10 md:p-14 text-center">
            <h3 className="font-heading text-xl sm:text-2xl md:text-4xl leading-tight">Elite competitor.<br />Proven relay contributor.<br />Emerging lifestyle brand.</h3>
            <p className="mt-5 md:mt-6 font-body text-sm md:text-base text-ivory/75 max-w-2xl mx-auto leading-relaxed">Leah partners with organizations that align with her values of excellence, authenticity, and empowerment. Together, we create meaningful campaigns that inspire and make an impact.</p>
            <div className="mt-7 md:mt-8 flex flex-col sm:flex-row flex-wrap gap-3 justify-center">
              <PrimaryButton onClick={() => scrollToId("contact")} testid="partner-inquiry-btn" className="w-full sm:w-auto">Partnership Inquiry</PrimaryButton>
              <GhostButton href={MEDIA_KIT_URL} testid="partner-mediakit-btn" className="w-full sm:w-auto !text-ivory !border-ivory/40 hover:!bg-ivory/10">Download Media Kit</GhostButton>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
